import { getFileMime } from "/WebInterface/new-ui/modules/advanced-download/common.js";
import { downloadFilesContainer } from "/WebInterface/new-ui/modules/advanced-download/template.js";
import Modal from "/WebInterface/new-ui/modules/modal.js";
import downloadingQueue from "/WebInterface/new-ui/modules/advanced-download/downloading-queue.js";
import { t } from "/WebInterface/new-ui/modules/localizations/localizations.js";
import store from "/WebInterface/new-ui/store/index.js";
import { _$ } from "/WebInterface/new-ui/assets/js/utils/dom.js";
import { growl } from "/WebInterface/new-ui/modules/toast.js";
import { showSaveFilePicker } from "/WebInterface/new-ui/assets/js/thirdparty/native-file-system-adapter-3.0.0/es6.js";

// export let advanceDownloads;
let dialog;

export const initAdvancedDownload = () => {
  dialog = new Modal({
    title: "Advanced Download",
    body: downloadFilesContainer({
      removeAllText: t("removeAll"),
    }),
    animate: false,
    show: false,
    backdrop: false,
    movable: true,
    closable: false,
    hasCloseOption: true,
    hasFooter: false,
    destroyOnClose: false,
    uniqueId: "UI_Download",
    extraClasses: ["files-to-download-modal"],
    minWidth: "860px",
    minHeight: "700px",
  });

  _$("#remove-all-button-advanced-download").on("click", () => {
    const downloadFiles = {};

    Object.values(store.downloadFilesDetails.files).forEach((file) => {
      const id = file?.id;

      if (
        file.status === "downloading" ||
        file.status === "pausing" ||
        file.status === "paused" ||
        file.status === "compressing" ||
        file.status === "sandboxDownloading"
      ) {
        downloadFiles[id] = file;
        return;
      }

      downloadingQueue?.remove(id, false);
    });

    store.dispatch("removeAllDownloadFiles", downloadFiles);
  });
};

export const showDownloadModal = () => {
  if (!dialog.visible()) {
    dialog.show(true);
  }
};

export const downloadFiles = async (files) => {
  const canUseWebSocketForDownloading = utils.getUserCustomizationValue(
    "useWSForAdvancedDownloads"
  );

  // First, collect all file handles by opening file pickers for all files
  const filesWithHandles = [];
  for (const file of files) {
    try {
      console.log(`Opening file picker for: ${file.name}`);
      let downloadType, storageMethod;
      const fileDownloadTypeByRange = utils.getDownloadTransferType(file.size);
      if (fileDownloadTypeByRange && fileDownloadTypeByRange !== "Normal") {
        [downloadType, storageMethod] = fileDownloadTypeByRange?.split("|");
      }

      console.log(
        `Saving file: ${file.name} Download Type: ${downloadType} Storage Method: ${storageMethod}`
      );
      const fileHandle = await showSaveFilePicker({
        suggestedName: file.name,
        _preferPolyfill: storageMethod === "sandbox",
        excludeAcceptAllOption: true,
        types: [getFileMime(file.name)],
      });

      console.log(
        "File picker params" +
          {
            suggestedName: file.name,
            _preferPolyfill: storageMethod === "sandbox",
            excludeAcceptAllOption: true,
            types: [getFileMime(file.name)],
          }
      );

      const downloadTypeBySimpleCustomization = canUseWebSocketForDownloading
        ? "WS"
        : "Normal";

      const _file = {
        ...file,
        id: utils.getUId(),
        fileHandle,
        downloadType: downloadType || downloadTypeBySimpleCustomization || "WS",
        storageMethod,
        status: "queued",
        progressStatus: {
          bytesDownloaded: 0,
        },
        timeStatus: {
          speed: 0,
          elapsedTime: 0,
          avg10SecSpeed: 0,
        },
      };

      filesWithHandles.push(_file);
      store.dispatch("setFilesInDownload", _file);
      downloadingQueue.addFileToQueue(_file);
    } catch (error) {
      console.log(`Error opening file picker for ${file.name}:`, error);
      // Continue with other files even if one fails
    }
  }

  // If no files were successfully processed, return early
  if (filesWithHandles.length === 0) {
    console.log("No files were successfully processed for download");
    return;
  }

  // Show download modal once all files are processed
  showDownloadModal();
};

// Common methods
const updateDownloadFileProgressBar = ({ fileId, size, maxSize }) => {
  const fileCard = _$(`#${fileId}`).el();
  if (fileCard) {
    _$(fileCard).find(".progress").attr("value", size);
    _$(fileCard).find(".progress").attr("max", maxSize);

    const updatedValue = parseInt(size);

    const completedValue = utils.formatBytes(updatedValue);
    const maxValue = utils.formatBytes(maxSize);

    const percentage = Math.ceil((size / maxSize) * 100);

    _$(fileCard).find("#completed-percentage").text(`${percentage} %`);

    _$(fileCard)
      .find(".download-progress-status #fileSizeDownloaded")
      .text(`${completedValue}`);

    _$(fileCard)
      .find(".download-progress-status #fileSize")
      .text(`${maxValue}`);

    _$(fileCard).find(".download-progress-status").removeClass("is-hidden");
    _$(fileCard).find(".progress-bar-container").removeClass("is-hidden");
  }
};

const updateGlobalProgressBar = (size) => {
  const downloadingFiles = downloadingQueue.getGlobalDownloadedFiles();
  const completedFiles = downloadingQueue.getCompletedFiles();

  let totalBytesToDownload = 0;
  let totalBytesDownloaded = Number(size);

  downloadingFiles.forEach((file) => {
    totalBytesToDownload += Number(file.size);
  });

  completedFiles.forEach((file) => {
    totalBytesDownloaded += Number(file.size);
  });

  updateDownloadFileProgressBar({
    fileId: "globalDownloads",
    size: totalBytesDownloaded,
    maxSize: totalBytesToDownload,
  });
};

// subscribe events
export const advancedDownloadSubscribeEvents = [
  {
    eventName: "updateProgressBarDownload,updateFileStatusDownloadDisk",
    callback: (action, payload) => {
      const onlyDiskUpdate = action === "updateFileStatusDownloadDisk";
      if (action === "updateFileStatusDownloadDisk") {
        console.log("Check here", payload);
      }
      const { fileId } = payload;

      const downloadingFileCard = _$(`#${fileId}`);
      if (!downloadingFileCard.el()) return;

      const file = store.downloadFilesDetails.files[fileId];
      const shouldShowProgress =
        file &&
        (file.status === "downloading" ||
          file.status === "paused" ||
          file.status === "pausing" ||
          file.status === "compressing");

      const progressBarContainer = downloadingFileCard.find(
        ".progress-bar-container.progress-bar:not(.disk-progress-container)",
        true
      );

      const progressPercentage = downloadingFileCard.find(
        ".completed-percentage",
        true
      );

      const progressStatusWrapper = downloadingFileCard.find(
        ".download-progress-status",
        true
      );

      if (!shouldShowProgress) {
        progressBarContainer?.classList.add("is-hidden");
        progressPercentage?.classList.add("is-hidden");
        progressStatusWrapper?.classList.add("is-hidden");
        return;
      } else {
        progressBarContainer?.classList.remove("is-hidden");
        progressPercentage?.classList.remove("is-hidden");
        progressStatusWrapper?.classList.remove("is-hidden");
      }

      if (!onlyDiskUpdate) {
        const { bytesDownloaded, fileSize } = payload;
        const calculatePercentage = Math.min(
          parseInt((bytesDownloaded / fileSize) * 100),
          99
        );
        const downloadedBytesFormatted = utils.formatBytes(bytesDownloaded);

        const downloadedSizeFormatted = downloadingFileCard.find(
          ".fileSizeDownloaded",
          true
        );

        const progressBar = downloadingFileCard.find(
          ".progress-bar-container.progress-bar:not(.disk-progress-container) .progress",
          true
        );

        progressPercentage.innerText = `${calculatePercentage}%`;
        downloadedSizeFormatted.innerText = `${downloadedBytesFormatted}`;

        progressBar.setAttribute("value", bytesDownloaded);
        progressBar.setAttribute("max", fileSize);
        updateGlobalProgressBar(bytesDownloaded);
      } else {
        const { bytesWritten, fileSize } = payload;
        const diskWriteInfo = downloadingFileCard.find(
          ".disk-write-info",
          true
        );

        if (bytesWritten) {
          const progressBarDisk = downloadingFileCard.find(
            ".disk-progress-container .progress",
            true
          );

          const progressPercentageDisk = downloadingFileCard.find(
            ".disk-completed-percentage",
            true
          );

          const calculatePercentageDisk = Math.min(
            parseInt((bytesWritten / fileSize) * 100),
            99
          );
          const downloadedBytesFormattedDisk = utils.formatBytes(bytesWritten);

          diskWriteInfo.classList.remove("is-hidden");
          progressBarDisk.setAttribute("value", bytesWritten);
          progressBarDisk.setAttribute("max", fileSize);
          progressPercentageDisk.innerText = `${calculatePercentageDisk}% ${downloadedBytesFormattedDisk}`;
        } else {
          diskWriteInfo.classList.add("is-hidden");
        }
      }
    },
  },
  {
    eventName: "updateTimeStatusDownload",
    callback: (action, payload) => {
      const { fileId, speed, elapsedTime, timeRemaining, bytesWritten } =
        payload;

      const fileCard = _$(`#${fileId}`).el();
      if (!fileCard) return;

      const downloadingSpeed = utils.formatBytes(speed);
      const _elapsedTime = utils.formatTime({
        secs: elapsedTime,
        minLabel: "m",
        secondsLabel: "s",
      });
      const _timeRemaining = timeRemaining
        ? utils.formatTime({
            secs: timeRemaining,
            minLabel: "m",
            secondsLabel: "s",
          })
        : "-";

      _$(fileCard)
        .find(".download-progress-status .downloadingSpeed")
        .text(`${downloadingSpeed}/s`);

      _$(fileCard)
        .find(".download-progress-status .elapsedTime")
        .text(`${_elapsedTime}`);

      _$(fileCard)
        .find(".download-progress-status .remainingTime")
        .html(`${_timeRemaining}`);

      _$(fileCard).find(".download-progress-status").removeClass("is-hidden");
      if (bytesWritten) {
        const realSpeed = bytesWritten / elapsedTime;
        const diskCompletedSpeed = utils.formatBytes(realSpeed);
        _$(fileCard)
          .find(".disk-completed-speed")
          .text(`${diskCompletedSpeed}/s`);
      }
      store.dispatch("updateGlobalDownloadTime");
    },
  },
  {
    eventName: "updateTenSecondAverageDownload",
    callback: (action, payload) => {
      const { fileId, speed } = payload;

      const fileCard = _$(`#${fileId}`).el();
      if (!fileCard) return;

      const downloadingAvg10SecSpeed = utils.formatBytes(speed);

      _$(fileCard)
        .find(".download-progress-status .downloadingAvg10SecSpeed")
        .text(`${downloadingAvg10SecSpeed}/s`);

      _$(fileCard).find(".download-progress-status").removeClass("is-hidden");
    },
  },
];

// Function to copy debug information to clipboard
const copyDebugInfoToClipboard = async (fileId) => {
  try {
    // Check if showServerReadProgress is enabled
    const showServerReadProgress =
      store.userInfo.userCustomizations?.showServerReadProgress?.value;
    if (!showServerReadProgress) {
      console.warn(
        "Debug information is disabled. Enable showServerReadProgress to view debug info"
      );
      return;
    }

    // Get the file data from store
    const fileData = store.downloadFilesDetails.files[fileId];
    if (!fileData) {
      console.warn(`File data not found for ID: ${fileId}`);
      return;
    }

    // Get the current download instance if it exists
    const currentDownloadInstance =
      downloadingQueue.getCurrentDownloadingFileInstance();

    let debugInfo = `=== DOWNLOAD DEBUG: ${
      fileData.name || fileData.href_path
    } ===\n`;
    debugInfo += `File ID: ${fileId}\n`;
    debugInfo += `Size: ${utils.formatBytes(fileData.size || 0)}\n`;
    debugInfo += `Status: ${fileData.status}\n`;
    debugInfo += `Download Type: ${fileData.downloadType || "Normal"}\n`;
    debugInfo += `Time: ${new Date().toLocaleString()}\n\n`;

    // Add file-specific debug information
    if (fileData.downloadingError) {
      debugInfo += `=== DOWNLOAD ERROR ===\n`;
      debugInfo += `${fileData.downloadingError}\n\n`;
    }

    if (fileData.timeTakenToComplete) {
      debugInfo += `=== DOWNLOAD STATS ===\n`;
      debugInfo += `Download Time: ${(
        fileData.timeTakenToComplete / 1000
      ).toFixed(2)} seconds\n`;
      debugInfo += `\n`;
    }

    // Add current download instance debug info if this is the current file
    if (
      currentDownloadInstance &&
      currentDownloadInstance.streamingFile?.id === fileId &&
      typeof currentDownloadInstance.formatDebugInfo === "function"
    ) {
      try {
        // Use the same formatDebugInfo method as the debug panel for consistency
        const wsDebugInfo = currentDownloadInstance.formatDebugInfo();
        debugInfo += wsDebugInfo;
      } catch (error) {
        debugInfo += `=== WEBSOCKET DEBUG ===\n`;
        debugInfo += `Error getting debug info: ${error.message}\n`;
      }
    } else {
      debugInfo += `=== WEBSOCKET DEBUG ===\n`;
      debugInfo += `File not currently being downloaded via WebSocket\n`;
      debugInfo += `This means the file is either:\n`;
      debugInfo += `- Completed successfully\n`;
      debugInfo += `- Failed and stopped\n`;
      debugInfo += `- Waiting in queue\n`;
      debugInfo += `- Using normal download (not WebSocket)\n`;
    }

    // Copy to clipboard
    await navigator.clipboard.writeText(debugInfo);

    // Show success message
    growl(
      "Debug info copied",
      "Debug information copied to clipboard.",
      2000,
      false
    );
    console.log("Debug information copied to clipboard:", debugInfo);
  } catch (error) {
    console.error("Error copying debug info to clipboard:", error);
    growl(
      "Failed to copy debug info",
      "Unable to copy debug information.",
      2000,
      true
    );
  }
};

// Function to add Alt+Click event listeners to download file cards
const addAltClickListeners = () => {
  // Remove existing listeners to avoid duplicates
  document.removeEventListener("click", handleAltClick);

  // Add new listener
  document.addEventListener("click", handleAltClick);
};

// Handle Alt+Click on download file cards
const handleAltClick = (event) => {
  // Check if Alt key is pressed
  if (!event.altKey) return;

  // Check if showServerReadProgress is enabled
  const showServerReadProgress =
    store.userInfo.userCustomizations?.showServerReadProgress?.value;
  if (!showServerReadProgress) {
    return;
  }

  // Find the closest download file card
  const downloadCard = event.target.closest(".download-file-card");
  if (!downloadCard) return;

  // Prevent default behavior
  event.preventDefault();
  event.stopPropagation();

  // Get file ID from parent wrapper - the wrapper has the file ID as its id attribute
  const fileCardWrapper = downloadCard.closest(".download-file-card-wrapper");
  if (!fileCardWrapper) {
    console.warn("No file card wrapper found");
    return;
  }

  // Get file ID from the wrapper's ID attribute
  const fileId = fileCardWrapper.id;
  if (!fileId) {
    console.warn("No file ID found on download card wrapper");
    return;
  }

  // Copy debug info to clipboard
  copyDebugInfoToClipboard(fileId);
};

// Initialize Alt+Click listeners when module loads
if (typeof document !== "undefined") {
  // Wait for DOM to be ready
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", addAltClickListeners);
  } else {
    addAltClickListeners();
  }
}
